(() => {
  if (window.__NVL_PROOF_STORY__) return;
  window.__NVL_PROOF_STORY__ = true;

  document.querySelectorAll('[data-nvp-route]').forEach((route) => {
    const buttons = [...route.querySelectorAll('[data-route-mode]')];
    const footLocal = route.querySelector('[data-route-foot="local"]');
    const footRemote = route.querySelector('[data-route-foot="remote"]');
    const setMode = (mode) => {
      route.classList.toggle('is-local', mode === 'local');
      route.classList.toggle('is-remote', mode === 'remote');
      buttons.forEach((button) => {
        const active = button.dataset.routeMode === mode;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-selected', String(active));
      });
      if (footLocal) footLocal.hidden = mode !== 'local';
      if (footRemote) footRemote.hidden = mode !== 'remote';
    };
    buttons.forEach((button) => button.addEventListener('click', () => setMode(button.dataset.routeMode)));
    setMode('local');
  });

  document.querySelectorAll('[data-nvp-proof]').forEach((proof) => {
    const tabs = [...proof.querySelectorAll('[data-proof-tab]')];
    const panels = [...proof.querySelectorAll('[data-proof-panel]')];
    const activate = (name) => {
      tabs.forEach((tab) => {
        const active = tab.dataset.proofTab === name;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', String(active));
      });
      panels.forEach((panel) => {
        const active = panel.dataset.proofPanel === name;
        panel.classList.toggle('is-active', active);
        panel.classList.remove('is-animate');
        if (active && (name === 'frametime' || name === 'latency')) {
          requestAnimationFrame(() => requestAnimationFrame(() => panel.classList.add('is-animate')));
        }
      });
    };
    tabs.forEach((tab) => tab.addEventListener('click', () => activate(tab.dataset.proofTab)));
    activate('one-low');
  });
})();
